import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "rootElement",
  class: "d-flex flex-column justify-content-between h-100"
}
const _hoisted_2 = { class: "row row-name mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "col-12"
}
const _hoisted_4 = { class: "row row-settings mb-2" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = {
  key: 1,
  class: "col-12 mb-2"
}
const _hoisted_7 = {
  key: 2,
  class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2"
}
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = {
  key: 3,
  class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = { class: "row align-items-center pt-3 border-top border-1 border-black border-opacity-25" }
const _hoisted_14 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_15 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_16 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    (!_ctx.pageUI.getIsReady())
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.pageUI.getIsReady())
        ? (_openBlock(), _createBlock(_component_dp_form, {
            key: 0,
            as: "form",
            onSubmit: _ctx.submitData,
            novalidate: ""
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.mode === _ctx.PageDetailModeEnum.NEW)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_input_select, {
                            modelValue: _ctx.createTriggerType,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.createTriggerType) = $event)),
                            name: _ctx.$t('type'),
                            label: _ctx.$t('type'),
                            options: _ctx.triggerTypeOptions,
                            rules: "required",
                            errors: errors,
                            onChange: _ctx.selectTriggerType
                          }, null, 8, ["modelValue", "name", "label", "options", "errors", "onChange"])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.triggerTypeDescription), 1)
                    ])),
                (_ctx.theTriggerType === _ctx.PopupTriggerTypeEnum.TIME_DELAY_TRIGGER)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_InputNumber, {
                          modelValue: _ctx.timeDelayTrigger.time_in_seconds,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timeDelayTrigger.time_in_seconds) = $event)),
                          modelModifiers: { trim: true },
                          label: _ctx.$t('timeInSeconds'),
                          name: "timeInSeconds",
                          min: 1,
                          step: 1,
                          rules: "required",
                          errors: errors,
                          onChange: _ctx.onTriggerChanged
                        }, null, 8, ["modelValue", "label", "errors", "onChange"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.theTriggerType === _ctx.PopupTriggerTypeEnum.CODE_TRIGGER)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.codeTrigger.js_event,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.codeTrigger.js_event) = $event)),
                          modelModifiers: { trim: true },
                          label: _ctx.$t('jsEvent'),
                          name: "jsEvent",
                          rules: `atLeastOneOfTwo:cssSelector,${_ctx.$t('jsEvent')},${_ctx.$t('cssSelector')}|max:200`,
                          errors: errors,
                          onChange: _ctx.onTriggerChanged
                        }, null, 8, ["modelValue", "label", "rules", "errors", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.codeTrigger.css_selector,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.codeTrigger.css_selector) = $event)),
                          modelModifiers: { trim: true },
                          label: _ctx.$t('cssSelector'),
                          name: "cssSelector",
                          rules: `atLeastOneOfTwo:jsEvent,${_ctx.$t('cssSelector')},${_ctx.$t('jsEvent')}|max:200`,
                          errors: errors,
                          onChange: _ctx.onTriggerChanged
                        }, null, 8, ["modelValue", "label", "rules", "errors", "onChange"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.mode === _ctx.PageDetailModeEnum.EDIT || _ctx.theTriggerType !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.$t('save')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_base_offcanvas_button_close, {
                      ref: "closeButton",
                      class: "btn btn-light"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
                      ]),
                      _: 1
                    }, 512)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true)
    ], 512)
  ], 64))
}